<!--
xls-export-button
用例：
<xls-export-button @click="afterClick" >Click</xls-export-button>

事件：
@click="handleExportClick"

最终会在 layouts/Management 监听导出的结果，并且下载文件
//-->
<template>
  <el-button class="button-component btn btn-default btn-sm" type="primary" :disabled="disabled" @click="_triggerClickEvent()">
    <svg-icon
      class="icon left-icon"
      :style="'margin-top: ' + marginTop + 'px'"
      width="12"
      height="12"
      src="/images/export.svg"
      fill="#fff"
    ></svg-icon>
    {{ export_cxcel }}
  </el-button>
</template>

<script>
import { ExportDoneEvent, MaxExportCount } from '@/constants/global_variables'
export default {
  props: {
    /**
     * 导出的内容类型，主要是用于消息追踪。如果是订单，则填写 orders; 充电站则 charge_stations
     *
     */
    exportType: {
      type: String,
      default: null
    },
    recordsCount: {
      type: Number,
      default: 0
    },
    marginTop: {
      type: Number,
      default: -2
    }
  },
  data() {
    return {
      disabled: true,
      export_cxcel: ''
    }
  },
  created() {
    // 检测当前报表的状态
    this.fetchStatus(this.exportType)
    let self = this

    // management 通知已完成下载，按钮释放状态
    management.$on(ExportDoneEvent, function(download_type) {
      if (download_type === self.exportType) {
        self.disabled = false
        self.export_cxcel = self.$t('common.export_excel')
      }
    })
  },
  methods: {
    /**
     * 点击了下载，触发 click event
     */
    _triggerClickEvent() {
      if (this.recordsCount > MaxExportCount) {
        this.$toast.warn(this.$t('common.data_much', [MaxExportCount]))
        return
      }
      this.$emit('click')
      this.disabled = true
      this.export_cxcel = this.$t('common.is_exporting')
    },
    /**
     * 检测当前报表的可下载状态
     *
     * @param {string} exportType 下载的内容
     */
    fetchStatus(exportType) {
      let params = { type: exportType }
      this.$http.get('/backend/export_files/status', { params: params }).then(response => {
        if (response.data.status === 'idle') {
          this.disabled = false
          this.export_cxcel = this.$t('common.export_excel')
        } else {
          this.export_cxcel = this.$t('common.is_exporting')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.button-component {
  .icon {
    font-size: 10px;
    height: 12px;
    width: 12px;
  }
  .left-icon {
    margin-left: -2px;
  }
  .right-icon {
    margin-right: -2px;
  }
}
</style>
